import React, { FocusEvent } from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";

import ErrorMessageComponent from "../ErrorMessage/ErrorMessage";
import "./form-select.scss";

interface Option {
  value: string;
  label: string;
}

interface FormSelectProps {
  options: Option[];
  value: string | null;
  placeholder?: string;
  label: string;
  required?: boolean;
  onChange: (value: string | null) => void;
  name: string;
  className?: string;
  labelClassName?: string;
  touched?: boolean;
  error?: string;
  defaultValue?: Option;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  isInvalid?: string | boolean;
  isValid?: boolean;
  setFieldError?: (field: string, message: string) => void;
  setFieldTouched?: (field: string, touched?: boolean) => void;
  isSearchable?: boolean;
  isClearable?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isMulti?: boolean;
}

const FormSelect: React.FC<FormSelectProps> = ({
  options,
  value,
  onChange,
  name,
  touched,
  error,
  setFieldError,
  setFieldTouched,
  placeholder,
  label,
  required,
  className,
  labelClassName = "",
  defaultValue,
  isSearchable = false,
  isLoading = false,
  isDisabled = false,
  isClearable = false,
  isMulti = false,
}) => {
  const selectedOption = value
    ? options.find((option) => option.value === value)
    : { label: placeholder ?? "", value: "" };

  const handleBlur = () => {
    if (setFieldTouched) {
      setFieldTouched(name, true);
    }
  };

  const handleChange = (option: Option | null) => {
    if (setFieldError) {
      setFieldError(name, "");
    }
    onChange(option?.value ?? "");
  };

  return (
    <>
      {label && (
        <Form.Label className={`m-0 fw-500 ${labelClassName}`}>
          {label}
          {required && <span>*</span>}
        </Form.Label>
      )}

      <Select
        className={`z-2 select-control-modal-style ${className}`}
        classNamePrefix="select"
        defaultValue={defaultValue}
        placeholder={placeholder}
        name={name}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        onBlur={handleBlur}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable={isSearchable}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            cursor: "pointer",
            borderColor: touched && error ? "#dc3545" : "hsl(0, 0%, 80%)",
          }),
          option: (baseStyles) => ({ ...baseStyles, cursor: "pointer" }),
        }}
        // isMulti={isMulti}
        // defaultMenuIsOpen
      />
      {error && (
        <div className="ps-2 pe-2">
          <ErrorMessageComponent touched={touched} error={error} />
        </div>
      )}
    </>
  );
};

export default FormSelect;
